import { lazyNamed } from 'src/utils/lazyNamed';

const Status = {
  NotFound: lazyNamed(() => import('./pages/NotFound'), 'NotFound'),
  Forbidden: lazyNamed(() => import('./pages/Forbidden'), 'Forbidden'),
  Maintenance: lazyNamed(() => import('./pages/Maintenance/index'), 'Maintenance'),
};

export default Status;
